/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown> }} Notifications_Message_Subject_Price_DropInputs */

const he_notifications_message_subject_price_drop = /** @type {(inputs: Notifications_Message_Subject_Price_DropInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ירידת מחיר: ${i?.itemName}`)
};

const en_notifications_message_subject_price_drop = /** @type {(inputs: Notifications_Message_Subject_Price_DropInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Price drop: ${i?.itemName}`)
};

/**
* | output |
* | --- |
* | "Price drop: {itemName}" |
*
* @param {Notifications_Message_Subject_Price_DropInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_subject_price_drop = /** @type {((inputs: Notifications_Message_Subject_Price_DropInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Subject_Price_DropInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_subject_price_drop(inputs)
	return en_notifications_message_subject_price_drop(inputs)
});